export default function* chain(...generators) {
    for (const g of generators) {
        yield* g;
    }
}
//# sourceMappingURL=chain.mjs.map